export default __webpack_public_path__ + "static/media/ico-light.88e07a1c.svg";